import { render, staticRenderFns } from "./AppointAdd.vue?vue&type=template&id=6e4662b4&scoped=true&"
import script from "./AppointAdd.vue?vue&type=script&lang=js&"
export * from "./AppointAdd.vue?vue&type=script&lang=js&"
import style0 from "./AppointAdd.vue?vue&type=style&index=0&id=6e4662b4&lang=less&scoped=true&"
import style1 from "./AppointAdd.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4662b4",
  null
  
)

export default component.exports